
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.209 20.341a.5.5 0 01-.357-.151l-7.71-7.905a.5.5 0 01.716-.7l7.351 7.538L23.142 3.81a.5.5 0 01.716.7L8.567 20.19a.5.5 0 01-.358.151z"}})])
          )
        }
      }
    